import type {FieldView, FieldCreateRequest, FieldType} from '@api/field/api.d';

type DesignerField = Partial<FieldView>;

export function convertBinding(binding: string | null | undefined): string | null {
    if (!binding) return null;
    return String(binding).replace(/[{}]/g, '').replace(/\./g, '_').toLowerCase();
}

export function buildFieldRequest(field: DesignerField): FieldCreateRequest {
    const apiType = field.type ? String(field.type).toLowerCase() as FieldType : undefined;
    const body: FieldCreateRequest = {
        font_family_id: field.font_family_id || 'string',
        font_size: field.font_size,
        font_color: field.font_color,
        type: apiType,
        name: field.name,
        value: field.value,
        page: field.page,
        top: field.top || 0,
        left: field.left || 0,
        width: field.width || 0,
        height: field.height || 0,
        is_required: Boolean(field.is_required),
        max_length: field.max_length
    };

    if (field.is_auto_field != null) {
        body.is_auto_field = field.is_auto_field;
    }
    const binding = convertBinding(field.binding);
    if (binding) {
        body.binding = binding as FieldCreateRequest['binding'];
    }

    if (apiType === 'date' && field.format) {
        body.format = field.format;
    }
    if ((apiType === 'checkbox' || apiType === 'radio') && field.group != null) {
        body.group = field.group;
    }
    if (apiType === 'textfield') {
        body.validation = {type: field.validation?.type ?? null};
    }
    if (apiType === 'list' && Array.isArray(field.accepted_values)) {
        body.accepted_values = field.accepted_values;
    }

    return body;
}
